import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';

export interface InputWithLabelUniDriver extends BaseUniDriver {
  getSuffixesCount: () => Promise<number>;
  hasErrorMessage: () => Promise<boolean>;
  getErrorMessage: () => Promise<string>;
  getValue: () => Promise<string>;
  clickInput: () => Promise<void>;
  enterText: (value: string) => Promise<void>;
  getLabelText: () => Promise<string>;
  isCustomInput: () => Promise<boolean>;
  isFocusedStyle: () => Promise<boolean>;
  getMaxLength: () => Promise<string | null>;
  getPlaceholder: () => Promise<string | null>;
}
